import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function TermsStepSchema() {
  const { t } = useTranslation('common')

  return z.object({
    acceptTerms: z.boolean().refine((val) => val === true, {
      message: t('validations.required'),
    }),
  })
}

export type TermsStepForm = z.infer<ReturnType<typeof TermsStepSchema>>
